import React from 'react';
import './Footer.css';

function Footer()
{
    return(
          <section className="bg-dark footer">
             <div className="container">
               <div className="row">  
                <div className="col-sm-12">
                  <h6 className="text-white text-center mb-3 mt-3">Copyright @ DevIncept</h6>
                  </div>  
               </div>
             </div>    
          </section>
    
    )
}

export default Footer;